const Dashboard = () => {
  return <div>Native Rating Dashboard</div>;
};

export default Dashboard;
